export const pblVettingModalSurface = {
  backgroundColor: '#fff',
  borderRadius: '40px 40px 40px 0px',
  boxShadow: 'none',
};

export const pblVettingInfoModalScrollArea = {
  maxHeight: 'calc(100vh - 136px)',
  overflowY: 'auto',
  paddingRight: '24px',
  scrollbarGutter: 'stable',
};
